// Mock data for Gazeal Advance

// Fall through reasons with realistic names and display names (first name + last initial)
export const fallThroughReasons = [
  { id: 1, name: "Marcus Turner", displayName: "Marcus T.", initials: "MT", message: "We've decided to stay put for now...", type: "seller" },
  { id: 2, name: "Deepak Sharma", displayName: "Deepak S.", initials: "DS", message: "Found somewhere cheaper, sorry!", type: "buyer" },
  { id: 3, name: "Fiona MacGregor", displayName: "Fiona M.", initials: "FM", message: "The survey scared us off.", type: "buyer" },
  { id: 4, name: "Raymond Chen", displayName: "Raymond C.", initials: "RC", message: "We've had a higher offer come in.", type: "seller" },
  { id: 5, name: "Priya Patel", displayName: "Priya P.", initials: "PP", message: "Our mortgage fell through.", type: "buyer" },
  { id: 6, name: "Trevor Blackwood", displayName: "Trevor B.", initials: "TB", message: "Changed our minds about moving.", type: "seller" },
  { id: 7, name: "Kwame Asante", displayName: "Kwame A.", initials: "KA", message: "The chain collapsed above us.", type: "buyer" },
  { id: 8, name: "Patricia Holloway", displayName: "Patricia H.", initials: "PH", message: "We're getting divorced actually...", type: "seller" },
  { id: 9, name: "Niamh O'Sullivan", displayName: "Niamh O.", initials: "NO", message: "Want £20k off or we walk.", type: "buyer" },
  { id: 10, name: "Gordon Fraser", displayName: "Gordon F.", initials: "GF", message: "Found a better property yesterday.", type: "buyer" },
  { id: 11, name: "Blessing Okonkwo", displayName: "Blessing O.", initials: "BO", message: "Seller wants more money now.", type: "buyer" },
  { id: 12, name: "Malcolm Pritchard", displayName: "Malcolm P.", initials: "MP", message: "Lost my job, can't proceed.", type: "buyer" },
];

export const agentLogos = Array.from({ length: 30 }, (_, i) => ({
  id: i + 1,
  name: `Agency ${i + 1}`,
  initials: `A${i + 1}`,
}));

// Featured quote from Sean Barrett
export const featuredQuote = {
  name: "Sean Barrett",
  role: "Agents Capital Founder & CEO, Fine & Country Surrey",
  quote: "Gazeal's Reservation Agreement system represents the most significant advancement in property transaction security we've seen in decades. It's not just about protecting commission - it's about bringing certainty to an industry plagued by uncertainty.",
  image: "https://customer-assets.emergentagent.com/job_bfedec72-4b0a-40b7-bc77-158aaceb834b/artifacts/0oz44sre_Sean%20Barrett.jpg"
};

// Agent testimonials with specific reviews provided
export const testimonials = [
  {
    id: 1,
    name: "Shaun Adams",
    role: "Owner, Cooper Adams",
    quote: "We list over 90% of our sales with a reservation agreement.",
    rating: 5,
  },
  {
    id: 2,
    name: "Alex Knight",
    role: "Director, Knight Edmonds",
    quote: "If you ask me when is the right time to introduce a reservation agreement, my answer is, Always!",
    rating: 5,
  },
  {
    id: 3,
    name: "Jack Flower",
    role: "Agent, eXp",
    quote: "We are Estate Agents who use Gazeal on all our deals. Highly recommend, great service and a beneficial product to both buyers and sellers.",
    rating: 5,
  },
  {
    id: 4,
    name: "Chris Ellis",
    role: "Owner, Harrisons Homes",
    quote: "Reservation Agreements are saving me £100K a year and I have been using Gazeal from 2020.",
    rating: 5,
  },
  {
    id: 5,
    name: "Billy Gill",
    role: "Area Director, Balgores",
    quote: "All my sellers will do it, otherwise, I WON'T TAKE THE LISTING.",
    rating: 5,
  },
];

export const faqItems = [
  {
    question: "What is Gazeal Advance?",
    answer: "Gazeal Advance is our new service that allows estate agents to access their commission at the offer stage when secured with a Gazeal Reservation Agreement, rather than waiting months until completion.",
  },
  {
    question: "How quickly can I receive my commission?",
    answer: "With Gazeal Advance, you can receive your commission within hours of the reservation agreement being signed. Our team processes requests as soon as possible.",
  },
  {
    question: "Do I have to withdraw my full commission?",
    answer: "No, you have complete flexibility. You can choose to withdraw all, some, or none of your commission, whatever suits your business needs at that moment.",
  },
  {
    question: "What is a Gazeal Reservation Agreement?",
    answer: "When a buyer and seller agree on a sale, both parties sign a Gazeal Reservation Agreement and commit a financial sum to prove they're serious. If either side walks away unreasonably, the committed party is compensated. Gazeal guarantees the commitment, so both sides are protected against anyone who isn't truly committed. And it's why 95% of Gazeal sales complete, compared to 70% without one.",
  },
  {
    question: "What happens if the sale falls through?",
    answer: "With a Gazeal Reservation Agreement, this is highly unlikely. Our agreements deliver a 95% success rate, giving you the strongest odds in the market. In the rare event a sale does fall through, you don't simply have to return the commission. We work with you to structure it, whether that's adjusting against your next sale or agreeing terms that suit how your business operates.",
  },
  {
    question: "Is there a cost to use Gazeal Advance?",
    answer: "There is a small fee for accessing your commission early. Full details are provided during the application process and are transparent with no hidden charges.",
  },
  {
    question: "How do I apply if I'm not yet a Gazeal agent?",
    answer: "You can join our waitlist by completing the application form. We'll review your application and schedule a call to discuss how Gazeal Advance can work for your business.",
  },
  {
    question: "Do I have to use Gazeal Agreements?",
    answer: "No, you don't. However, early commission access through Gazeal Advance is only available on sales secured with a Reservation Agreement. Otherwise, your commission is paid at exchange, rather than at completion as is typically the case.",
  },
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Secure the Sale",
    description: "Complete a Gazeal Reservation Agreement with your buyer and seller at the offer stage.",
    icon: "Shield",
  },
  {
    step: 2,
    title: "Request Commission",
    description: "Submit your commission advance request through our simple portal.",
    icon: "Send",
  },
  {
    step: 3,
    title: "Get Paid",
    description: "Receive your commission within hours, not months. Choose how much you want to withdraw.",
    icon: "Banknote",
  },
];

export const stats = [
  { value: "£5B+", label: "Property Transactions Processed" },
  { value: "30,000+", label: "Home Movers Secured" },
  { value: "1,000+", label: "Trusted Agents" },
  { value: "95%", label: "Success Rate to Exchange" },
];

// Scotland vs Gazeal comparison data
export const scotlandComparison = {
  mapImage: "https://customer-assets.emergentagent.com/job_bfedec72-4b0a-40b7-bc77-158aaceb834b/artifacts/jextnavv_Scotland%20versus%20Gazeal.png",
  gazealRate: "5%",
  scotlandRate: "12.2%",
  englandAverage: "24%",
  regions: [
    { name: "Scotland", rate: "12.2%", color: "orange" },
    { name: "Gazeal", rate: "5%", color: "green" },
    { name: "London", rate: "27%", color: "red" },
    { name: "South East", rate: "26.3%", color: "red" },
    { name: "South West", rate: "25.6%", color: "red" },
    { name: "Eastern", rate: "25.6%", color: "red" },
  ]
};
